<template>
  <component
    :is="to ? 'RouterLink' : 'button'"
    class="nav-bar-button"
    :class="{
      'nav-bar-button--highlight': highlightEnabled,
      'nav-bar-button--font-color-black': fontColor === 'black',
      active: isActiveForced && highlightEnabled && to === null,
    }"
    :to="to"
    :exact="exact"
  >
    <div class="navbar-button__icon">
      <slot />
    </div>

    <span class="navbar-button__title" data-test-id="navbar-button__title">
      <slot name="title" />
    </span>
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'NavBarButton',

  props: {
    to: {
      type: Object,
      default: null,
    },

    exact: {
      type: Boolean,
      default: false,
    },

    highlightEnabled: {
      type: Boolean,
      default: true,
    },

    fontColor: {
      type: String,
      default: 'default',
      validator(value) {
        return ['black', 'default'].includes(value);
      },
    },

    /**
     * If true and no `to` prop provided, the item will be highlighted if the highlightEnabled prop is true
     */
    isActiveForced: {
      type: Boolean,
      default: false,
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';
@use 'mixins/typography';
@use 'mixins/button';

.nav-bar-button {
  min-width: 40px;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: settings.$border-radius;
  transition: all 0.1s ease-in-out;
  background: transparent;
  color: colors.$color-grey-600;
  box-shadow: none;

  container-type: inline-size;

  &--font-color-black {
    color: colors.$color-black;
  }

  &--highlight {
    &:hover {
      color: colors.$color-grey-600;
      background-color: colors.$color-grey-200;
    }

    &.active {
      color: colors.$color-grey-600;
      background-color: colors.$color-grey-200;
    }
  }

  .navbar-button__title {
    display: none;

    @include typography.typography-ellipsis;
    line-height: 22px; // to prevent font from being cut off at the bottom
  }

  .navbar-button__icon {
    @include button.navbar-button;
  }

  @container (inline-size > 40px) {
    .navbar-button__title {
      padding-right: 12px;
      display: inline-block;
    }
  }
}
</style>
